document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.mt-hero-slider__container');
    if (!container) return;
    
    // 防止重复初始化
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';
    
    var slider = container.querySelector('.mt-hero-slider__slider');
    var originalSlides = Array.from(container.querySelectorAll('.mt-hero-slider__slide'));
    var leftBtn = container.querySelector('.mt-hero-slider__arrow--left');
    var rightBtn = container.querySelector('.mt-hero-slider__arrow--right');
    var dotsContainer = container.querySelector('.mt-hero-slider__dots');
    var autoplay = container.dataset.autoplay === 'true';
    var interval = parseInt(container.dataset.autoplay_interval || 5, 10) * 1000 || 5000;
    var timer = null;
    var progressTimer = null;
    var isAnimating = false;
    var progressBars = [];
    var progressStartTime = null;
    var isPaused = false;
  
    console.log('Initial slides count:', originalSlides.length);
  
    // 记录原始slide数量
    var realCount = originalSlides.length;
    
    // 克隆首尾slide
    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
    slider.appendChild(firstClone);
    slider.insertBefore(lastClone, originalSlides[0]);
    
    // 重新获取所有slides（包括克隆的）
    var slides = Array.from(container.querySelectorAll('.mt-hero-slider__slide'));
    var total = slides.length;
    var current = 1; // 初始定位到第1个真实slide
  
    console.log('After cloning - total slides:', total, 'real count:', realCount);
  
    function setSliderWidth() {
      slider.style.width = (slides.length * 100) + '%';
      slides.forEach(function(slide) {
        slide.style.width = (100 / slides.length) + '%';
      });
      // 重新定位，防止宽度变化导致白屏
      setPosition(current, false);
    }
    setSliderWidth();
    window.addEventListener('resize', setSliderWidth);
    // 图片加载后也调用
    slides.forEach(function(slide) {
      var img = slide.querySelector('img');
      if (img) img.onload = setSliderWidth;
    });
  
    function setPosition(idx, withAnim = true) {
      slider.style.transition = withAnim ? 'transform 0.6s cubic-bezier(.4,0,.2,1)' : 'none';
      slider.style.transform = 'translateX(' + (-idx * (100 / slides.length)) + '%)';
    }
  
    function goTo(idx, withAnim = true) {
      if (isAnimating) return;
      isAnimating = withAnim;
      setPosition(idx, withAnim);
      current = idx;
      updateProgressBars();
      startProgressAnimation();
    }
  
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
  
    function updateProgressBars() {
      dotsContainer.innerHTML = '';
      progressBars = [];
      
      for (let i = 0; i < realCount; i++) {
        var dot = document.createElement('button');
        dot.className = 'mt-hero-slider__dot' + (i === getRealIndex() ? ' mt-hero-slider__dot--active' : '');
        dot.setAttribute('aria-label', '切换到第' + (i + 1) + '张');
        dot.addEventListener('click', function () { goTo(i + 1); });
        
        // 创建进度条元素
        var progress = document.createElement('div');
        progress.className = 'mt-hero-slider__dot-progress';
        dot.appendChild(progress);
        
        progressBars.push(progress);
        dotsContainer.appendChild(dot);
      }
    }
  
    function getRealIndex() {
      if (current === 0) return realCount - 1;
      if (current === total - 1) return 0;
      return current - 1;
    }
  
    // 监听动画结束实现无缝跳转
    slider.addEventListener('transitionend', function () {
      isAnimating = false;
      if (current === 0) {
        setPosition(realCount, false);
        current = realCount;
      }
      if (current === total - 1) {
        setPosition(1, false);
        current = 1;
      }
    });
  
    if (leftBtn) leftBtn.addEventListener('click', prev);
    if (rightBtn) rightBtn.addEventListener('click', next);
  
    function startProgressAnimation() {
      // 停止之前的进度动画
      if (progressTimer) {
        clearInterval(progressTimer);
      }
      
      var realIndex = getRealIndex();
      var currentProgressBar = progressBars[realIndex];
      
      if (!currentProgressBar) {
        return;
      }
      
      // 只重置当前进度条，不要重置所有进度条
      currentProgressBar.style.width = '0%';
      
      // 记录开始时间
      progressStartTime = Date.now();
      isPaused = false;
      
      // 开始当前进度条动画
      progressTimer = setInterval(function() {
        if (isPaused) return;
        
        var elapsed = Date.now() - progressStartTime;
        var progress = Math.min((elapsed / interval) * 100, 100);
        
              currentProgressBar.style.width = progress + '%';
      
      if (progress >= 100) {
        clearInterval(progressTimer);
        // 进度条完成时自动切换到下一张
        goTo(current + 1);
      }
      }, 16); // 约60fps
    }
  
    function pauseProgress() {
      isPaused = true;
      if (progressTimer) {
        clearInterval(progressTimer);
      }
    }
  
    function resumeProgress() {
      if (!isPaused) return;
      
      var realIndex = getRealIndex();
      var currentProgressBar = progressBars[realIndex];
      
      if (!currentProgressBar) return;
      
      // 计算剩余时间
      var elapsed = Date.now() - progressStartTime;
      var remaining = interval - elapsed;
      
      if (remaining <= 0) return;
      
      // 恢复进度动画
      progressTimer = setInterval(function() {
        if (isPaused) return;
        
        var currentElapsed = Date.now() - progressStartTime;
        var progress = Math.min((currentElapsed / interval) * 100, 100);
        
        currentProgressBar.style.width = progress + '%';
        
        if (progress >= 100) {
          clearInterval(progressTimer);
          // 进度条完成时自动切换到下一张
          goTo(current + 1);
        }
      }, 16);
    }
  
    function startAutoplay() {
      // 移除自动播放计时器，改为由进度条控制切换
      // 进度条完成时会自动调用 goTo(current + 1)
    }
    
    function stopAutoplay() {
      pauseProgress();
    }
    
    function resumeAutoplay() {
      if (autoplay) {
        resumeProgress();
      }
    }
    // container.addEventListener('mouseenter', stopAutoplay);
    // container.addEventListener('mouseleave', resumeAutoplay);
  
      // 初始化
  console.log('Initializing slider...');
  setPosition(1, false);
  updateProgressBars();
  
  // 开始自动播放和进度动画
  startAutoplay();
  startProgressAnimation();
  });